import JoinMember from "javascripts/webpage/join-member";

document.addEventListener("DOMContentLoaded", () => {
  JoinMember();
});
